import { jsx } from "@emotion/react/jsx-runtime";
import { TableCell as TableCell$1 } from "@mui/material";
import clsx from "clsx";
const TableCell = ({
  highlight = false,
  ...props
}) => {
  return /* @__PURE__ */ jsx(TableCell$1, { className: clsx(highlight && "AscendTableCell-highlight"), ...props });
};
export {
  TableCell
};
//# sourceMappingURL=TableCell.js.map
